module.exports = __webpack_public_path__ + "static/img/6.ea58808.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/fg/6.png
// module id = 135
// module chunks = 2